import { render, staticRenderFns } from "./source-chip.vue?vue&type=template&id=238590d7&scoped=true"
import script from "./source-chip.vue?vue&type=script&lang=js"
export * from "./source-chip.vue?vue&type=script&lang=js"
import style0 from "./source-chip.vue?vue&type=style&index=0&id=238590d7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "238590d7",
  null
  
)

export default component.exports